import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  ClickToCallReqProps,
  ClickToCallResProps,
  GetCallStatusResProps,
  GetInterpreterLanguagesReqProps,
  GetInterpreterLanguagesResProps,
  GetRecentActiveCallResProps
} from './calls.types';

export const callsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getCallStatus: build.query<GetCallStatusResProps, string>({
      keepUnusedDataFor: 0,
      query: (callId) => `/calls/${callId}`
    }),
    getInterpreterLanguages: build.query<
      GetInterpreterLanguagesResProps,
      GetInterpreterLanguagesReqProps
    >({
      keepUnusedDataFor: 0,
      query: () => '/calls/interpreter-languages'
    }),
    getRecentActiveCall: build.query<GetRecentActiveCallResProps, void>({
      keepUnusedDataFor: 0,
      query: () => '/calls/recent?status=active'
    }),
    triggerClickToCall: build.mutation<ClickToCallResProps, ClickToCallReqProps>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/calls/click-to-call'
      })
    })
  }),
  reducerPath: 'callsApi',
  tagTypes: ['Calls']
});

export const {
  useGetInterpreterLanguagesQuery,
  useLazyGetCallStatusQuery,
  useLazyGetRecentActiveCallQuery,
  useTriggerClickToCallMutation
} = callsApi;
